interface SpacerProps {
  space: number
}

const Spacer = ({ space }: SpacerProps) => {
  return <div style={{ marginTop: space }}></div>
}

export default Spacer
